import { legacyResetLinkTarget } from './lib/legacy-reset-link'

// Buzola runs on the Navigation API; Firefox and Safari still need the polyfill. Load it before any router code.
const bootstrap = async () => {
	// Before the router starts, so the signed-out redirect to /login cannot race it (see legacyResetLinkTarget).
	const resetTarget = legacyResetLinkTarget(window.location.href)
	if (resetTarget) {
		window.history.replaceState(null, '', resetTarget)
	}
	if (!('navigation' in window)) {
		await import('@virtualstate/navigation/polyfill')
	}
	await import('./index')
}

void bootstrap()
